/* LIVA · product page gallery (snippets/bv-pdp-gallery.liquid).
   Colour filter, mobile counter, full-screen viewer with zoom, Tam Görünüm card colour.
   bv.js still owns the form, price, size states and sticky bar; this file only listens to the colour fieldset. */
(() => {
  const init = (pdp) => {
    const pg = pdp.querySelector('[data-bv-pg]');
    if (!pg || pg.dataset.ready) return;
    pg.dataset.ready = '1';
    const track = pg.querySelector('[data-bv-pg-track]');
    const items = [...track.children];
    const iEl = pg.querySelector('[data-bv-pg-i]');
    const nEl = pg.querySelector('[data-bv-pg-n]');
    const pEl = pg.querySelector('[data-bv-pg-p]');
    let data = {};
    try { data = JSON.parse(pdp.querySelector('[data-bv-product]').textContent); } catch (e) {}
    const ci = data.colorIndex;
    const colorFs = ci !== null && ci !== undefined ? pdp.querySelector(`[data-bv-option="${ci}"]`) : null;
    const visible = () => items.filter((li) => !li.hidden);

    const onScroll = () => {
      const v = visible();
      if (!v.length) return;
      const step = v[0].getBoundingClientRect().width + 6;
      const i = Math.max(0, Math.min(v.length - 1, Math.round(track.scrollLeft / step)));
      iEl.textContent = i + 1;
      nEl.textContent = v.length;
      pEl.style.width = `${((i + 1) / v.length) * 100}%`;
    };
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(onScroll); }, { passive: true });

    const card = pdp.querySelector('[data-bv-look-card]');
    const setCard = (c) => {
      if (!card) return;
      const imgs = [...card.querySelectorAll('img[data-c]')];
      const hit = imgs.find((im) => im.dataset.c === c) || imgs[0];
      imgs.forEach((im) => { im.hidden = im !== hit; });
      card.dataset.look = hit.dataset.c;
    };
    if (card) {
      card.addEventListener('click', () => {
        const r = document.querySelector(`#takim input[name="bvs-color"][value="${card.dataset.look}"]`);
        if (r && !r.checked) { r.click(); r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }

    // Desktop grid: a run of half-width images with an odd count leaves a hole; let its last image span both columns.
    const fill = () => {
      items.forEach((li) => li.classList.remove('bv-pg__item--fill'));
      let run = [];
      const close = () => { if (run.length % 2 === 1) run[run.length - 1].classList.add('bv-pg__item--fill'); run = []; };
      visible().forEach((li) => { if (li.classList.contains('bv-pg__item--wide')) close(); else run.push(li); });
      close();
    };
    const applyColor = (c, reset) => {
      items.forEach((li) => {
        const cs = li.dataset.c;
        li.hidden = !(cs === '*' || cs.split(',').includes(c));
      });
      const first = visible()[0];
      const img = first && first.querySelector('img');
      if (img) img.loading = 'eager';
      if (reset) track.scrollTo({ left: 0, behavior: 'auto' });
      fill();
      onScroll();
      setCard(c);
    };
    if (colorFs) {
      colorFs.addEventListener('change', (e) => { if (e.target.matches('input')) applyColor(e.target.value, true); });
      const checked = colorFs.querySelector('input:checked');
      if (checked) setCard(checked.value);
    }
    fill();
    onScroll();

    /* ---------- full-screen viewer ---------- */
    const dlg = pg.querySelector('[data-bv-pv]');
    const vt = dlg.querySelector('[data-bv-pv-track]');
    const vi = dlg.querySelector('[data-bv-pv-i]');
    const vn = dlg.querySelector('[data-bv-pv-n]');
    const cap = dlg.querySelector('[data-bv-pv-cap]');
    let opener = null;
    let slides = [];
    const cur = () => Math.round(vt.scrollLeft / Math.max(1, vt.clientWidth));
    const sync = () => {
      const i = Math.max(0, Math.min(slides.length - 1, cur()));
      vi.textContent = i + 1;
      vn.textContent = slides.length;
      cap.textContent = slides[i] ? slides[i].dataset.k : '';
      slides.forEach((s, k) => { if (k !== i) s.classList.remove('is-zoom'); });
    };
    const go = (d) => { vt.scrollTo({ left: (cur() + d) * vt.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    const open = (li) => {
      const v = visible();
      vt.textContent = '';
      slides = v.map((it) => {
        const src = it.querySelector('img');
        const s = document.createElement('div');
        s.className = 'bv-pv__slide';
        s.dataset.k = it.dataset.k || '';
        const im = document.createElement('img');
        if (src.srcset) { im.srcset = src.srcset; im.sizes = '100vw'; }
        im.src = src.currentSrc || src.src;
        im.alt = src.alt;
        im.decoding = 'async';
        s.appendChild(im);
        vt.appendChild(s);
        return s;
      });
      opener = li.querySelector('[data-bv-pg-open]');
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      const idx = Math.max(0, v.indexOf(li));
      requestAnimationFrame(() => { vt.scrollLeft = idx * vt.clientWidth; sync(); });
    };
    items.forEach((li) => li.querySelector('[data-bv-pg-open]').addEventListener('click', () => open(li)));
    vt.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dlg.querySelector('[data-bv-pv-prev]').addEventListener('click', () => go(-1));
    dlg.querySelector('[data-bv-pv-next]').addEventListener('click', () => go(1));
    dlg.querySelector('[data-bv-pv-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      vt.textContent = '';
      slides = [];
      if (opener) opener.focus({ preventScroll: true });
    });
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    // Click to zoom; while zoomed the image follows the pointer.
    const origin = (s, e) => {
      const r = s.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      s.querySelector('img').style.transformOrigin = `${x}% ${y}%`;
    };
    vt.addEventListener('click', (e) => {
      const s = e.target.closest('.bv-pv__slide');
      if (!s) return;
      origin(s, e);
      s.classList.toggle('is-zoom');
    });
    vt.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const s = e.target.closest('.bv-pv__slide.is-zoom');
      if (s) origin(s, e);
    });
  };
  const boot = () => document.querySelectorAll('[data-bv-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
